import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const NepalFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				x='0.25'
				y='0.25'
				width='19.5'
				height='13.5'
				rx='1.75'
				fill='white'
				stroke='#F5F5F5'
				strokeWidth='0.5'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M0 1.7328C0 0.775803 0.775802 -6.1594e-10 1.7328 2.93282e-10C1.84501 3.99886e-10 1.95479 0.032682 2.04872 0.094053L9.58401 5.01711C10.6938 5.74216 10.1804 7.46667 8.85475 7.46667H5.71429L10.5981 11.6545C11.5377 12.4602 10.9679 14 9.73013 14H2C0.895428 14 0 13.1046 0 12V1.7328Z'
				fill='white'
			/>
			<mask
				id='mask0_2332_15652'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='12'
				height='14'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 1.7328C0 0.775803 0.775802 -6.1594e-10 1.7328 2.93282e-10C1.84501 3.99886e-10 1.95479 0.032682 2.04872 0.094053L9.58401 5.01711C10.6938 5.74216 10.1804 7.46667 8.85475 7.46667H5.71429L10.5981 11.6545C11.5377 12.4602 10.9679 14 9.73013 14H2C0.895428 14 0 13.1046 0 12V1.7328Z'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_15652)'>
				<path
					d='M9.73013 13.3333H0.666667V0.666667H1.70629L9.21938 5.57522C9.77427 5.93775 9.51756 6.8 8.85475 6.8H5.71429C5.43533 6.8 5.18586 6.97368 5.08905 7.2353C4.99224 7.49693 5.06856 7.79116 5.28032 7.97275L10.1641 12.1606C10.6339 12.5634 10.349 13.3333 9.73013 13.3333Z'
					fill='#EE1B44'
					stroke='#0543A8'
					strokeWidth='1.33333'
					strokeLinejoin='round'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M4.89291 5.46048C5.16727 5.38679 5.42021 5.28601 5.64392 5.16324C5.42203 5.9531 4.68381 6.53328 3.80731 6.53328C2.93082 6.53328 2.1926 5.9531 1.9707 5.16324C2.19503 5.28635 2.44876 5.38735 2.724 5.46109L3.09451 5.13328L2.48897 4.59752L3.30372 4.6383L3.26211 3.83984L3.8088 4.43328L4.35549 3.83984L4.31387 4.6383L5.12863 4.59752L4.52308 5.13328L4.89291 5.46048ZM3.07988 11.9912L3.8088 11.1999L4.53772 11.9912L4.48223 10.9266L5.56857 10.981L4.76118 10.2666L5.56857 9.55227L4.48223 9.60664L4.53772 8.54203L3.8088 9.33328L3.07988 8.54203L3.13536 9.60664L2.04903 9.55227L2.85642 10.2666L2.04903 10.981L3.13536 10.9266L3.07988 11.9912Z'
					fill='white'
				/>
			</g>
		</svg>
	);
};

export default NepalFlagIcon;
